let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aNg21")).then(() => parcelRequire('5PagH'));